import { render, staticRenderFns } from "./UpdatedAt.vue?vue&type=template&id=9a680398"
import script from "./UpdatedAt.vue?vue&type=script&lang=js"
export * from "./UpdatedAt.vue?vue&type=script&lang=js"
import style0 from "./UpdatedAt.vue?vue&type=style&index=0&id=9a680398&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports